// import systemBbList from '../components/systemBb/systemBbList.vue'

export default [
    { 
        path: 'systemBb/systemBbList',
        component: resolve => require(['@/components/systemBb/systemBbList'],resolve),
        name:'SystemBbList',
        meta:{
            id:'957',
            node:'systemBb',
            url:'systemBbList',
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/systemBb.js